import { Form, Input } from 'antd';

import { SCRAPER_REQ_FIELD_KEY } from '../../configs/scraper-field-map/field-const';

export const LinkField = (props: { required?: boolean }) => {
  const { required = false } = props;
  return (
    <Form.Item
      label="Link"
      name={SCRAPER_REQ_FIELD_KEY.LINK}
      required={required}
      rules={required ? [{ required: true, message: 'Link is required' }] : []}
    >
      <Input placeholder="Type link" />
    </Form.Item>
  );
};
